import { onLoaded, updateContent, emitEvent } from "@/utils"

// Prevent multiple initializations
let formsInitialized = false

const Forms = () => {
    // Prevent re-initialization
    if (formsInitialized) {
        return
    }

    const settings = ajaxpress_vars.settings || {}

    const shouldIgnoreForm = (form) => {
        if (!form) return true

        if (form.classList && form.classList.contains('ajaxpress-ignore')) {
            return true
        }

        if (settings.ignore_forms) {
            const ignoreSelectors = settings.ignore_forms
                .split(',')
                .map(s => s.trim())
                .filter(s => s.length > 0)

            for (let selector of ignoreSelectors) {
                try {
                    if (form.matches(selector) || form.closest(selector)) {
                        return true
                    }
                } catch (e) {
                    console.warn('AjaxPress: Invalid selector in ignore_forms:', selector)
                }
            }
        }

        if (form.getAttribute('enctype') === 'multipart/form-data') {
            return true
        }

        const action = form.getAttribute('action') || window.location.href
        if (action.includes('wp-admin') || action.includes('wp-login')) {
            return true
        }

        return false
    }

    const handleFormSubmission = async function (e) {
        const form = e.target

        if (!form || !form.matches || !form.matches('form')) {
            return
        }

        if (shouldIgnoreForm(form)) {
            return
        }

        e.preventDefault()

        const formData = new FormData(form)
        const action = form.getAttribute('action') || window.location.href
        const method = (form.getAttribute('method') || 'GET').toUpperCase()

        try {
            form.classList.add('ajaxpress-form-processing')

            emitEvent('ajaxpress-loading', {
                url: action,
                source: 'form'
            })

            const options = {
                method: method,
                headers: {
                    'AjaxPress-Ajax': 'true'
                }
            }

            if (method === 'POST') {
                options.body = formData
            }

            const url = method === 'GET'
                ? `${action}?${new URLSearchParams(formData).toString()}`
                : action

            const response = await fetch(url, options)
            const html = await response.text()

            form.classList.remove('ajaxpress-form-processing')

            updateContent(html)

            emitEvent('ajaxpress-updated', {
                html: html
            })

            if (window.history && window.history.pushState) {
                window.history.pushState(
                    {
                        url: url,
                        source: 'ajaxpress'
                    },
                    '',
                    url
                )
            }

        } catch (err) {
            form.classList.remove('ajaxpress-form-processing')
            console.error('AjaxPress: Form submission failed:', err)
        }
    }

    const init = function () {
        // Prevent re-initialization
        if (formsInitialized) {
            return
        }

        // Mark as initialized
        formsInitialized = true

        document.addEventListener('submit', handleFormSubmission, false)
    }

    onLoaded(init)
}

export default Forms
